"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var ResizeSpy = /*#__PURE__*/ function() {
    "use strict";
    function ResizeSpy() {
        var _this = this;
        _classCallCheck(this, ResizeSpy);
        this.targets = [];
        this.observer = new ResizeObserver(function(entries) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function(_iterator, _step) {
                    var entry = _step.value;
                    var target = _this.targets.find(function(t) {
                        return t.el === entry.target;
                    });
                    if (target) target.cb({
                        width: entry.contentRect.width,
                        height: entry.contentRect.height
                    });
                };
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop(_iterator, _step);
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        window.addEventListener('resize', function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = _this.targets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var target = _step.value;
                    if (_instanceof(target.el, Window)) target.cb({
                        width: document.documentElement.clientWidth,
                        height: document.documentElement.clientHeight
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        ResizeSpy.instance = this;
    }
    var _proto = ResizeSpy.prototype;
    _proto.reset = function reset() {
        this.targets = [];
    };
    ResizeSpy.getInstance = function getInstance() {
        if (!ResizeSpy.instance) ResizeSpy.instance = new ResizeSpy();
        return ResizeSpy.instance;
    };
    ResizeSpy.watch = function watch(el, cb, options) {
        var spy = ResizeSpy.getInstance();
        spy.targets.push({
            el: el,
            cb: cb
        });
        if (_instanceof(el, HTMLElement)) spy.observer.observe(el);
        if (options === null || options === void 0 ? void 0 : options.immediate) {
            if (_instanceof(el, Window)) cb({
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            });
            else cb({
                width: el.clientWidth,
                height: el.clientHeight
            });
        }
        return function() {
            spy.targets = spy.targets.filter(function(t) {
                return t.el !== el && t.cb !== cb;
            });
        };
    };
    return ResizeSpy;
}();
var _default = ResizeSpy;
exports.default = _default;
